import { Link } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionTag, SectionTitle } from "./Reveal";

const QUESTIONS = [
  {
    q: "O totem de ponto atende à Portaria 671?",
    a: "Sim. O Ultra gera os arquivos fiscais exigidos (AFD e AEJ), mantém espelho de ponto eletrônico com assinatura digital do colaborador e registra geolocalização e biometria de forma segura e auditável.",
  },
  {
    q: "Como funciona o envio de alertas pelo WhatsApp?",
    a: "Usamos um número oficial verificado do Ultra. Quando um checklist detecta temperatura fora da faixa, não é executado no horário ou registra uma ocorrência crítica, o gestor da unidade recebe o alerta no WhatsApp — inclusive fora da janela de 24 h, via template aprovado pela Meta.",
  },
  {
    q: "Preciso de uma impressora térmica específica para as etiquetas?",
    a: "Não. O Ultra imprime em qualquer térmica com bobina 50×30 mm (Zebra, Elgin, Bematech, Argox…) via ZPL/ESC-POS e também exporta grades de etiquetas em PDF para folhas adesivas A4 comuns.",
  },
  {
    q: "O colaborador consegue burlar o checklist usando foto da galeria?",
    a: "Não. A execução em tempo real bloqueia uploads de fotos antigas, valida a geolocalização no momento do registro e usa visão computacional para conferir se a foto corresponde ao equipamento inspecionado.",
  },
  {
    q: "Como funciona a baixa de estoque com a câmera do celular?",
    a: "Cada etiqueta impressa carrega um QR Code único do lote. Ao abrir a embalagem, o cozinheiro aponta a câmera de qualquer celular ou tablet logado no Ultra e a baixa é registrada em menos de 1 segundo, respeitando a fila PVPS.",
  },
  {
    q: "Posso testar gratuitamente antes de contratar?",
    a: "Sim. São 14 dias de teste gratuito com acesso a todos os módulos (checklists, ponto e estoque), sem cartão de crédito e sem fidelidade.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="landing-faq" className="bg-white py-24 border-t border-stone-200 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-[minmax(0,1fr)] lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <SectionTag>Perguntas frequentes</SectionTag>
          <SectionTitle className="!text-3xl sm:!text-4xl">Tudo o que a operação pergunta antes de começar.</SectionTitle>
          <p className="mt-4 font-body text-base text-stone-600">
            Não achou sua dúvida? Nosso time conhece cozinha por dentro.
          </p>
          <Link to="/register" className="inline-block mt-6">
            <Button variant="outline" className="border-stone-300 bg-white hover:bg-stone-100 font-body h-11 rounded-lg" data-testid="faq-support-cta">
              <LifeBuoy className="h-4 w-4 mr-2" /> Falar com um especialista
            </Button>
          </Link>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <Accordion type="single" collapsible className="divide-y divide-stone-200 border-y border-stone-200">
            {QUESTIONS.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`} className="border-b-0" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-left font-display text-base sm:text-lg font-bold text-stone-950 hover:no-underline hover:text-emerald-800 [&>svg]:text-emerald-800" data-testid={`faq-trigger-${i}`}>
                  <span className="flex gap-4">
                    <span className="font-mono text-xs text-stone-400 pt-1.5">{String(i + 1).padStart(2, "0")}</span>
                    {item.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pl-10 font-body text-sm md:text-base text-stone-600 leading-relaxed" data-testid={`faq-content-${i}`}>
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
